import { memo } from 'react';

// @ts-ignore
import { FooterUsStyle } from './FooterUsStyle.tsx';

export * from './FooterUsStyle.tsx';

export default memo(FooterUsStyle);
